import { createExternalOptionsReferenceResolver } from '../createExternalOptionsReferenceResolver';
const cache = {};

const toCacheKey = (referenceType, objectTypeId, options) => `${referenceType}-${objectTypeId || 'default'}-${Boolean(options.searchIncludeDeleted)}-${Boolean(options.useV3)}`;
/**
 * Returns a cached reference resolver for the given referenceType and objectTypeId.
 *
 * If the same referenceType and objectTypeId have been used before, the
 * existing resolver will be returned from the cache.
 *
 * @param {string} referenceType a `ReferenceTypes` constant
 * @param {string} objectTypeId (optional) objectTypeId to pass to the resolver
 * @param {Object} options.httpClient (optional) httpClient to forward to the
 * resolver
 * NOTE: the `httpClient` option only applies the first time a resolver is requested for
 * a `objectTypeId/referenceType` pair. Subsequent calls will return the cached
 * resolver instead.
 * @returns a `ReferenceResolver`
 */


export const createStandardCachedResolver = (referenceType, objectTypeId, options = {}) => {
  const {
    httpClient,
    searchIncludeDeleted,
    useV3 = false
  } = options;
  const cacheKey = toCacheKey(referenceType, objectTypeId, options);

  if (!cache[cacheKey]) {
    cache[cacheKey] = createExternalOptionsReferenceResolver({
      objectTypeId,
      referenceType,
      httpClient,
      searchFetchOptions: {
        includeDeleted: Boolean(searchIncludeDeleted)
      },
      useV3
    });
  }

  return cache[cacheKey];
};